import React from "react"

import { Container, Row, Col } from 'reactstrap'
import Link from '../components/link'
import Button from '../components/btn'
import Layout from "../components/layout"
import SEO from "../components/seo"
import { FaPhone } from 'react-icons/fa'
import Form from '../components/form'
import Slider from '../components/slider'
import Box from '../components/box'
import Hr from '../components/hr'
import { FaHome, FaBath } from 'react-icons/fa';
import { MdKitchen } from 'react-icons/md';
import Benefits from '../components/benefits'
import styled from 'styled-components'
import CinewallBg from "../components/cinewallbg";

let StyledBackground = styled.div`
  background: linear-gradient(to bottom,#f9fbfd 0,#fff 100%);
`

const CineWallContainer = styled(Container)`
  position: relative;
  padding: 0 !important;
  clip-path: polygon(0 0, 100% 0, 100% 85%, 0 100%);
`

let Service = ({title, Icon = FaHome}) => (
  <Col>
    <Link to="/">
      <Box>
        <Icon size={30}/>
        <h4 className="mt-3">{title}</h4>
      </Box>
    </Link>
  </Col>
)

export default () => (
  <Layout>
    <SEO title="Home" />
    <CineWallContainer fluid={true}>
        <CinewallBg/>
        <Slider/>
    </CineWallContainer>

    <Container className="pt-4">
      <div className="text-center">
        <h4>Specialist in maatwerk interieurbouw</h4>
        <p className="text-muted">Wij ontwerpen, bouwen en plaatsen maatwerk meubelen en complete interieurs. Voor een nieuwe inrichting waar u jarenlang plezier van heeft. Van woningen tot bedrijfspanden; samen creeren wij de beleving van prachtige ruimtes met functioneel design</p>
      </div>
    </Container>
    <Container className="py-5">
      <h2 className="text-center mb-4">Specialisaties</h2>
      <Row>
        <Service title="Cinewall"/>
        <Service title="Badkamer" Icon={FaBath} />
        <Service title="Keuken" Icon={MdKitchen} />
      </Row>
    </Container>
    <div className="text-center py-5">
      <Button to="/contact" className="btn btn-primary btn-lg">
        <FaPhone className="mr-1"/>
        Neem direct contact op
      </Button>
    </div>
    <StyledBackground>
      <Benefits/>
      <div className="py-5">
        <Container>
          <Row className="d-flex justify-content-center">
            <Col md={8}>
              <Box style={{textAlign: 'left'}}>
                <h3 className="text-center">Mogelijkheden bespreken?</h3>
                <Hr/>
                <Form/>
              </Box>
            </Col>
          </Row>
        </Container>
      </div>
    </StyledBackground>
  </Layout>
)
